export const criarConfigBuscaContrato = (idOrganizacao) => ({
  label: 'Contrato',
  placeholder: 'Nº Contrato...',
  titulo: 'Buscar Contrato',
  endpointApi: 'ContratosCompra',
  idField: 'idContratoCompra',
  displayField: 'numeroContratoFornecedor',
  descField: 'numeroContratoFornecedor',
  tabela: 'ContratoCompra',
  camposFiltro: [
    { label: 'Nº Contrato', model: 'busca', tipo: 'text' },
    { label: 'Data do Contrato', model: 'dataContrato', tipo: 'date' },
    {
      label: 'Status',
      model: 'lstStatusContrato',
      tipo: 'select',
      optionsEndpoint: 'ListasCliente/lookup/COMPRA_ST_CONTRATO'
    }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idContratoCompra', width: '8%' },
    { header: 'Nº Contrato', dataField: 'numeroContratoFornecedor', width: '20%' },
    { header: 'Data do Contrato', dataField: 'dataContrato', width: '15%', tipo: 'date' },
    { header: 'Fornecedor', dataField: 'nomeFornecedor', width: '35%' },
    { header: 'Status', dataField: 'lstStatusContrato', width: '20%' }
  ],
  filtrosFixos: { idOrganizacao }
})
